import posthog from 'posthog-js'

export const capturePosthogException = (error, { pathname, profileId, release }) => {
    const properties = {
        app_release: release,
        app_path: pathname,
    }

    if (profileId !== null && profileId !== undefined) {
        properties.profile_id = String(profileId)
    }

    try {
        const replayUrl = posthog.get_session_replay_url?.({ withTimestamp: true })
        if (replayUrl) {
            properties.posthog_replay_url = replayUrl
        }
    } catch {
        // Session replay context is optional and must not prevent error reporting.
    }

    try {
        posthog.captureException(error, properties)
    } catch {
        // PostHog reporting must not disrupt the Bugsnag error boundary.
    }
}
